module.exports = __webpack_public_path__ + "img/ic_adp.7afdfa34.svg";